/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef, useEffect } from "react";
import AgentHeader from "./AgentHeader";
import AgentMessage from "./AgentMessage";
import SuggestedActions from "./SuggestedActions";
import ChatMessage from "./ChatMessage";
import AgentFooter from "./AgentFooter";
import "../../../styles/IntakeAgent.css";
import { AGENTS } from "../agents/agentRegistry";
import { useNavigate } from "react-router-dom";
import getSuggestedActionLabels from "../../../utils/getSuggestedActionLabels";
import INTENT_TYPES from "../../../constants/intentTypes";

const IntakeAgentPanel = ({
  userName = "User",
  applicationCount = 9,
  onRunDuplicateCheck,
  onSaveForLater,
  onClose,
  agentName,
  isReviewAgentScreen,
  defaultMsg = null,
  logedInUserMail,
  isAgentPanelOpen,
}) => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [threadId, setThreadId] = useState(null);
  const { runDuplicateLabel, saveLaterLabel } = getSuggestedActionLabels(agentName);

  const triggerDuplicateCheck = () => {
    const userPrompt = `Run duplicate check on all ${applicationCount} applications`;

    setMessages((prev) => [...prev, { sender: "user", text: userPrompt }]);
    onRunDuplicateCheck?.();

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          sender: "agent",
          text: `Got it! I'm reviewing ${applicationCount} applications for duplicate check:`,
          tasks: [
            { label: "Running Fuzzy Matching across historical applications", status: "done" },
            { label: "Checking applicant details", status: "done" },
            { label: "Checking mailing address details", status: "done" },
            { label: "Checking damaged property details", status: "progress" },
          ],
          showSuggestedActions: true,
        },
      ]);
    }, 800);
  };
  const mapChatResponse = (config, showReport, normalized) => {
    setMessages((prev) => {
      const updated = [...prev];

      // Find last "thinking" message
      const thinkingIndex = updated
        .map((m, i) => (m.status === "thinking" ? i : -1))
        .filter((i) => i !== -1)
        .pop();

      if (thinkingIndex === undefined) return updated;

      if (normalized) {
        updated[thinkingIndex] = {
          sender: "agent",
          agent: config?.id,
          ...normalized,
          status: "complete",
          showViewReportButton: showReport,
        };
      } else {
        updated.splice(thinkingIndex, 1);
      }

      return updated;
    });
  };

  const handleSendMessage = async (text) => {
    if (!text?.trim() || isLoading) return;

    setMessages((prev) => [...prev, { sender: "user", text }]);
    setIsLoading(true);
    setMessages((prev) => [
      ...prev,
      {
        sender: "agent", text: "", status: "thinking", id: Date.now(),
      },
    ]);

    try {
      const token = process.env.REACT_APP_AGENTIC_AZURE_AI_TOKEN;
      const agentConfig = AGENTS[agentName];

      if (!agentConfig?.sendMessage) {
        throw new Error("sendMessage not defined for agent");
      }

      const raw = await agentConfig.sendMessage({
        message: text,
        agentConfigName: agentConfig,
        threadId,
        token,
      });

      const normalized = agentConfig.normalize(raw);
      if (!threadId && raw.thread_id) {
        setThreadId(raw.thread_id);
      }
      const reportPayload = agentConfig.id === "DocumentProcessingAgent"
        ? {
          agentId: agentConfig.id,
          ...normalized,
        }
        : {
          agentId: agentConfig.id,
          summary: raw.response,
          counts: normalized.counts,
          matches: normalized.matches,
          clusters: normalized.clusters,
          sourceCaseId: normalized.source_case_id,
          input_record: normalized.outputText?.output_text?.input_record,
          intent: normalized.intent,
          agent: normalized.agent,
        };

      // setReportData(reportPayload);
      const REPORT_ENABLED_AGENTS = [
        "review-intake-a1",
        "benefit-agent-b1",
        "application-status-agent",
        "eligibility-review-agent",
        "eligibility-review-agent-e1",
        "DocumentProcessingAgent",
        "eligibility-review-agent-e1",
      ];

      const isReportEnabledAgent = REPORT_ENABLED_AGENTS.includes(agentConfig.id);

      let showViewReportButton = false;
      if (agentConfig.id === "DocumentProcessingAgent") {
        // Show if documents exist
        showViewReportButton = normalized.outputText?.output_text?.caseSummary?.totalFiles > 0;
      } else {
        const allowedIntents = [
          INTENT_TYPES.DUPLICATE_CHECK_BY_CASE_ID,
          INTENT_TYPES.STATUS_CHECK_BY_CASE_ID,
          INTENT_TYPES.ELGIBILITY_REVIEW,
        ];

        const intent = normalized.intent || normalized.raw?.output_text?.intent;

        showViewReportButton = isReportEnabledAgent && (allowedIntents.includes(intent));
      }

      mapChatResponse(agentConfig, showViewReportButton, normalized);
    } catch (e) {
      console.error(e);

      let errorMessage = `Something went wrong while contacting the Agent. Try again shortly.`;

      try {
        const parsed = JSON.parse(e.message);
        errorMessage = parsed?.detail?.message
          || parsed?.message
          || errorMessage;
      } catch {
        errorMessage = e.message;
      }
      mapChatResponse({}, false, null);
      setMessages((prev) => [
        ...prev,
        { sender: "agent", type: "error", summary: errorMessage },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuggestedActions = (isSave = false) => {
    const prompt = isSave ? saveLaterLabel : runDuplicateLabel;
    handleSendMessage(prompt);
  };

  const getLastAgentId = () => {
    for (let i = messages.length - 1; i >= 0; i--) {
      if (messages[i].sender === "agent" && messages[i].agent) {
        return messages[i].agent;
      }
    }
    return null;
  };

  const getReportRouteByAgent = (agentId) => {
    switch (agentId) {
      case "review-intake-a1":
        if (agentName === "Application Status Agent") {
          return "/application-status-report";
        }
        return "/duplicate-report";

      case "benefit-agent-b1":
        return "/benefit-duplicate-report";

      case "DocumentProcessingAgent":
        return "/documentQuality-report";

      case "eligibility-review-agent-e1":
        return "/eligibility-review-report";
        
      case "application-status-agent":
        return "/application-status-report";

      default:
        return null;
    }
  };

  const navigate = useNavigate();

  const handleViewReport = (normalized) => {
    const agentConfig = AGENTS[agentName];
    const isEligibilityAgent = agentConfig.id === "eligibility-review-agent-e1";
    setReportData({
      agentId: agentConfig.id,
      summary: isEligibilityAgent
        ? normalized.raw?.output_text?.report?.response : normalized.summary,
      counts: normalized.counts,
      matches: normalized.matches,
      clusters: normalized.clusters,
      sourceCaseId: normalized.source_case_id,
      input_record: isEligibilityAgent
        ? normalized.raw?.output_text?.case_data : normalized.outputText?.output_text?.input_record,
      intent: normalized.intent,
      agent: normalized.agent,
      documentRows: normalized.documentRows || [],
      type: "run_summary",
      caseRow: normalized.caseRow,
      outputText: normalized.apiResponse || normalized.outputText?.output_text,
      case_status: normalized.case_status,
      caseId: normalized.caseId,
    });
  };
  useEffect(() => {
    if (!reportData) return;

    const route = getReportRouteByAgent(reportData.agentId);

    navigate(route, {
      state: {
        reportData,
      },
    });

    onClose?.();
  }, [reportData]);
  const lastAgentId = getLastAgentId();

  const autoBottomRef = useRef(null);

  useEffect(() => {
    autoBottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  useEffect(() => {
    if (defaultMsg) handleSendMessage(defaultMsg);
  }, [defaultMsg]);

  return (
    <div className="agent-container">
      <AgentHeader
        onClose={onClose}
        agentName={agentName}
        isReviewAgentScreen={isReviewAgentScreen}
      />

      <div className="agent-body">
        {messages.length > 0 ? (
          <div className="chat-messages">
            {messages.map((msg, i) => (
              <div key={i} className="single-message">
                <ChatMessage
                  {...msg}
                  agentName={agentName}
                  onRunDuplicateCheck={onRunDuplicateCheck}
                  onSaveForLater={onSaveForLater}
                  status={msg.status || "complete"}
                  logedInUserMail={logedInUserMail}
                  isAgentPanelOpen={isAgentPanelOpen}
                />

                {msg.sender === "agent"
                  // && i === messages.length - 1
                  && (
                    <SuggestedActions
                      applicationCount={applicationCount}
                      onRunDuplicateCheck={() => handleViewReport(msg)}
                      onSaveForLater={onSaveForLater}
                      disabled={isLoading}
                      runDuplicateLabel={
                        lastAgentId === "benefit-agent-b1"
                          ? "Benefits Report"
                          : "View Report"
                      }
                      reportData={reportData}
                      showViewReportButton={msg.showViewReportButton}
                    />
                  )}

              </div>
            ))}

            <div ref={autoBottomRef} />
          </div>
        ) : (
          <>
            <AgentMessage
              agentName={agentName}
              userName={userName}
              applicationCount={applicationCount}
              logedInUserMail={logedInUserMail}
            />

            <SuggestedActions
              applicationCount={applicationCount}
              onRunDuplicateCheck={() => handleSuggestedActions()}
              onSaveForLater={() => handleSuggestedActions(true)}
              showViewReportButton="true"
              saveLaterLabel={saveLaterLabel}
              runDuplicateLabel={runDuplicateLabel}
            />
          </>
        )}

      </div>

      <AgentFooter onSendMessage={handleSendMessage} disabled={isLoading} isAgentPanelOpen={isAgentPanelOpen} />
    </div>
  );
};

export default IntakeAgentPanel;
